
  import { defineComponent } from "vue";
  import Card from "primevue/card";
  import Button from "primevue/button";

  export default defineComponent({
    name: "Cards",
    components: {
      Card,
      Button
    },
    props: {
      name: String,
      src: String,
      aside: String,
      content: Array,
      urls: Array,
      id: Number,
      handleOnClick: Function
    }
  });
